import DynamicLegal from "@/pages/legal/DynamicLegal";

export default function Privacy() {
  return <DynamicLegal pageKey="privacy" />;
}
